import axios from 'axios';

// Use VITE_API_URL for production (Render backend)
// Fall back to relative path '/api/v1' for development (Vite proxy)
const baseURL = import.meta.env.VITE_API_URL || '/api/v1';

const apiClient = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle auth & subscription errors
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid - clear auth and redirect
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }

        if (
            error.response?.status === 402 &&
            error.response?.data?.code === 'TRIAL_EXPIRED'
        ) {
            // Trial has expired - trigger the global payment wall
            window.dispatchEvent(new CustomEvent('cresta:trial-expired'));
        }

        return Promise.reject(error);
    }
);

export default apiClient;

